import BannerGeneral from "../components/BannerGeneral";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import BlockRightImage from "../components/BlockRightImage";

import useContentful from "../hooks/use-contenful";
import BlockLeftImage from "../components/BlockLeftImage";

import Accordion from "../components/Accordion";

import {
  DistanciaContinuos,
  PresencialInscripcion,
  PresencialNuevos,
  PresencialContinuos,
  TecnologiasContinuos,
  PosgradoPostulacion,
  PosgradoNuevos,
} from "../components/Pasos";

function Matricula() {


  return (
    <>
      <div className="wrapper-matricula margin">
        <Breadcumbs
          content={
            <>
              <NavLink to="/matriculas">Matricúlate ahora</NavLink>
            </>
          }
        ></Breadcumbs>

        <div className="layout6">
          <center>
            <h2>
              <b>¡Matricúlate ahora</b> y descubre todo lo que necesitas saber
              sobre los enlaces de registro, fechas, procesos y calendario
              académico adaptado a tu programa de estudios!{" "}
            </h2>
            <p>
              <b>Ya seas un estudiante nuevo o continuo,</b> aquí encontrarás
              todo lo necesario para planificar tu periodo académico.
            </p>
          </center>
        </div>
        <div className="margin">
          <BlockLeftImage
            src="https://utpl.edu.ec/recursos/img/distancia.gif"
            alt="utpl"
            content={
              <>
                <h3>
                  Carreras <b>a Distancia </b>
                </h3>
                <p>
                  <b>Matricúlate ahora </b>como:
                </p>
                <a href="https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService">
                  Estudiante continuo
                </a>
                <DistanciaContinuos></DistanciaContinuos>

                <div className="margin">
                  <Accordion
                    title="Fechas de matrícula"
                    content={
                      <>
                        <p>
                          <b>Periodo octubre 2024 - febrero 2025</b>
                        </p>
                        <p>Próximamente fechas de matrícula.</p>
                        <p>
                          <b>Inicio de actividades académicas:</b> 14 de octubre
                          de 2024
                        </p>
                        <p></p>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="Calendario académico"
                    content={<></>}
                  ></Accordion>
                </div>
              </>
            }
          ></BlockLeftImage>
        </div>

        <div className="graybg relative">
          <BlockRightImage
            src="https://utpl.edu.ec/recursos/img/presencial.gif"
            alt="utpl"
            content={
              <>
                <h3>
                  Carreras <b>Presencial</b>
                </h3>

                <a href="https://prapps.utpl.edu.ec/ords/utpl_crm/r/registro-utpl/login">
                  <b>Inscríbete ahora a la prueba de admisión </b>
                </a>

                <PresencialInscripcion></PresencialInscripcion>

                <h4>
                  ¿Fuiste admitido como <b>estudiante nuevo?</b>
                </h4>

                <a href="https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService">
                  Matricúlate ahora
                </a>
                <PresencialNuevos></PresencialNuevos>
                <h4>
                  ¿Eres estudiante de <b>segundo ciclo en adelante?</b>
                </h4>

                <a href="https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService">
                  Matricúlate ahora
                </a>
                <PresencialContinuos></PresencialContinuos>

                <div className="margin">
                  <Accordion
                    title="Fechas de matrícula"
                    content={
                      <>
                        <p>
                          <b>Periodo octubre 2024 - febrero 2025</b>{" "}
                        </p>
                        <p>
                          <b>Inscríbete</b> a la prueba de admisión{" "}
                          <b>hasta el 7 de agosto</b>
                        </p>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="Calendario académico"
                    content={
                      <>
                        <p>
                          <a href="https://www.utpl.edu.ec/carreras/sites/default/files/Calendario%20acad%C3%A9mico_202462%20%281%29.pdf">
                            Periodo abril - agosto 2024, todas las carreras
                          </a>
                        </p>
                        <p>
                          <a href="https://www.utpl.edu.ec/carreras/sites/default/files/Calendario%20acad%C3%A9mico%20medicina_202462.pdf">
                            Periodo abril - agosto 2024, medicina
                          </a>
                        </p>
                        <p>
                          <a href="https://www.utpl.edu.ec/carreras/sites/default/files/Calendario%20acad%C3%A9mico_Anual_MED%20ENF%20NUT_P_GR_202411.pdf">
                            Periodo mayo 2024 - abril 2025 - medicina,
                            enfermería, nutrición y dietética
                          </a>
                        </p>
                      </>
                    }
                  ></Accordion>
                </div>
              </>
            }
          ></BlockRightImage>
        </div>

        <BlockLeftImage
          src="https://utpl.edu.ec/recursos/img/tecnologias.gif"
          alt="utpl"
          content={
            <>
              <h3>
                Carreras <b>Tecnológicas </b>
              </h3>
              <p>
                <b>Matricúlate ahora </b>como:
              </p>
              <a href="https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService">
                Estudiante continuo
              </a>
              <TecnologiasContinuos></TecnologiasContinuos>

              <div className="margin">
                <Accordion
                  title="Fechas de matrícula"
                  content={
                    <>
                      <p>
                        <b>Periodo octubre 2024 - febrero 2025</b>
                      </p>
                      <p>Próximamente fechas de matrícula.</p>
                      <p>
                        <b>Inicio de actividades académicas:</b> 14 de octubre
                        de 2024
                      </p>
                    </>
                  }
                ></Accordion>

                <Accordion
                  title="Calendario académico"
                  content={<></>}
                ></Accordion>
              </div>
            </>
          }
        ></BlockLeftImage>

        <div className="graybg">
          <BlockRightImage
            src="https://utpl.edu.ec/recursos/img/posgrados.gif"
            alt="utpl"
            content={
              <>
                <h3>
                  <b>Posgrados</b>
                </h3>

                <a href="https://prapps.utpl.edu.ec/ords/utpl_crm/r/registro-utpl/login">
                  <b>Postula ahora </b>
                </a>
                <PosgradoPostulacion></PosgradoPostulacion>

                <h4>
                  ¿Fuiste admitido como <b>estudiante nuevo?</b>{" "}
                </h4>

                <a href="https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService">
                  Matricúlate ahora
                </a>
                <PosgradoNuevos></PosgradoNuevos>

                <div className="margin">
                  <Accordion
                    title="Fechas de matrícula"
                    content={
                      <>
                        <p>
                          <b>Periodo octubre 2024 - febrero 2025</b>
                        </p>
                        <p>Próximamente fechas de matrícula.</p>
                        <p>
                          <b>Inicio de actividades académicas:</b> 14 de octubre
                          de 2024
                        </p>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="Calendario académico"
                    content={<></>}
                  ></Accordion>
                </div>
              </>
            }
          ></BlockRightImage>
        </div>
      </div>

      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Matricula;
